import { Divider, Stack, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import TextInput from 'components/Common/TextInput';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import CustomButton from 'components/Common/CustomButton';
import CardWrapper from 'components/Common/CardWrapper';
import BankCardAutocomplete from 'components/Common/autocomplete/BankCardAutoComplete';
import { camelToSpacedPascalCase, formatAmount } from 'utils/helpers';
import { FULFILL_REQUEST } from 'types/sendAndRequest';
import { useState } from 'react';

export default function ConfirmRequestMoneyForm({ details, backButtonNavigation, handleUpdateStatus }: any) {
    const moneyContainerList = useSelector((state: RootState) => state.moneyContainer?.moneyContainerList) || [];
    const userInfo = useSelector((state: RootState) => state.user.userInfo);
    const { accountBalance } = userInfo || {};
    const [loading, setLoading] = useState(false);

    const formSchema = yup.object({
        amount: yup
            .string()
            .required('Amount is required.')
            .test('amount', `Amount must be greater than $0.00 `, (value: any) => !(Number(value) < 0.01))
            .test('amount', `Amount must be less than $${accountBalance} `, (value: any) => !(Number(value) < 0.01)),
        from: yup.string().required('From is required.'),
    });

    const {
        handleSubmit,
        getValues,
        formState: { errors },
        control,
        watch,
        setValue,
        trigger,
    } = useForm<any>({
        resolver: yupResolver<any>(formSchema),
        defaultValues: {
            to: details?.username,
            amount: formatAmount(details?.balance),
            from: moneyContainerList?.[0]?.detail?.containerId || null,
        },
    });
    const handleFormSubmit = async () => {
        const formData = getValues();
        setLoading(true);
        await handleUpdateStatus('PAID', formData?.from);
        setLoading(false)
    };

    return (
        <>
            <CardWrapper backButtonNavigation={backButtonNavigation}>
                <Typography sx={{ fontSize: 16, mb: 2, fontWeight: 400 }} variant="h1">
                    {camelToSpacedPascalCase(FULFILL_REQUEST)}
                </Typography>
                <Divider />
                <Typography sx={{ mt: 2, mb: 4 }} variant="body1">
                    Confirm the information below is correct and press Send Request to complete this transaction.
                </Typography>
                <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <Stack alignItems="center" gap={5} height={500}>
                        <TextInput disabled value={watch('to')} label="To" icon={null} sx={{ width: { xs: '100%', md: '50%' } }} />
                        <Controller
                            name="from"
                            control={control}
                            render={({ field: { ...rest } }) => (
                                <BankCardAutocomplete
                                    {...rest}
                                    sx={{ width: { xs: '100%', md: '50%' } }}
                                    label="Funding source"
                                    value={watch('from') || null}
                                    matchKey="detail.containerId"
                                    isOptionEqualToValue={(option) => {
                                        const value = option?.detail?.containerId === watch('from');
                                        return value;
                                    }}
                                    onChange={(_, option) => {
                                        setValue('from', option?.detail?.containerId);
                                        trigger('from');
                                    }}
                                    error={!!errors.from}
                                    helperText={(errors?.from as any)?.message}
                                />
                            )}
                        />

                        <TextInput
                            disabled
                            type={'currency'}
                            value={watch('amount')}
                            sx={{ width: { xs: '100%', md: '50%' } }}
                            label="Amount"
                            placeholder="$0.00"
                            icon={null}
                        />
                        <CustomButton loading={loading} type="submit" sx={{ fontSize: '26px', width: { xs: '90%', md: '40%' } }}>
                            Send
                        </CustomButton>
                    </Stack>
                </form>
            </CardWrapper>
        </>
    );
}
